/**
 * 文件说明:
 *
 * register global layout
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useMemo} from 'react'
import {getAuthLayoutData} from '../../util'
import GlobalLayout from './index'

function registerGlobalLayoutWrap(PageComponent) {
    const GlobalLayoutWrap = memo((props) => {
        const authLayoutData = useMemo(
            () => getAuthLayoutData(props?.location?.pathname),
            [props?.location?.pathname],
        )

        if (authLayoutData) {
            if (authLayoutData?.hzLayoutOption?.noUseGlobalLayoutComponent) {
                return <PageComponent {...props}>{props.children}</PageComponent>
            }

            return (
                <GlobalLayout
                    authLayoutData={authLayoutData}
                    PageComponent={PageComponent}
                    pageProps={props}
                >
                    {props.children}
                </GlobalLayout>
            )
        }

        return <PageComponent {...props}>{props.children}</PageComponent>
    })

    return GlobalLayoutWrap
}

export default registerGlobalLayoutWrap
